import styles from './style.module.css'
import { Nav, AccountMenu, LinkComponent } from '../index.js'
import Container from '../container'
import LogoHeader from '../../images/logo-header.png'

const Header = ({ loggedIn, onSignOut, orders }) => {
  return <header className={styles.header}>
    {/* Демо-плашка: доступы для просмотра проекта */}
    <div style={{
      background: '#fff3cf', color: '#4a3c00', padding: '8px 16px',
      fontSize: '13px', lineHeight: 1.55, borderBottom: '1px solid #e8d29a',
    }}>
      <div style={{ fontWeight: 700, letterSpacing: '0.03em', marginBottom: '2px' }}>
        🍲 Демо-проект Foodgram
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px 20px', justifyContent: 'center' }}>
        <span>
          <span style={{ fontWeight: 600 }}>Админка:</span>{' '}
          <a href="/foodgram/admin/" style={{ textDecoration: 'underline' }}>открыть ›</a>{' '}
          <span style={{ opacity: 0.7 }}>логин</span> <code>moderator@foodgram.local</code>{' '}
          <span style={{ opacity: 0.7 }}>пароль</span> <code>ModDemo#2026</code>
        </span>
        <span>
          <span style={{ fontWeight: 600 }}>Пользователь:</span>{' '}
          <a href="/foodgram/signin" style={{ textDecoration: 'underline' }}>войти ›</a>{' '}
          <span style={{ opacity: 0.7 }}>логин</span> <code>alice@foodgram.local</code>{' '}
          <span style={{ opacity: 0.7 }}>пароль</span> <code>AliceFood#2026</code>
        </span>
      </div>
    </div>
    <Container>
      <div className={styles.headerContent}>
        <LinkComponent
          className={styles.headerLink}
          title={<img className={styles.headerLogo} src={LogoHeader} alt='Foodgram' />}
          href='/'
        />
        <Nav
          loggedIn={loggedIn}
          onSignOut={onSignOut}
          orders={orders}
        />
      </div>
    </Container>
  </header>
}

export default Header
